<template>
  <!-- 导出年度分析报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box flex-box">
        <div>
          <div class="header_titles">
            <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
            <input id="completeNum" v-model="completeNum" v-show="false" />
            <h1>职业教育“{{ header.zykName }}”专业教学资源库({{ header.zykNum }})</h1>
            <h1 style="margin-top: 15px">{{ yearText }}年上半年运行数据分析报告</h1>
            <div class="number_time">
              <div>
                <span>主持单位：{{ header.allHostUnit }}</span>
                <span>分析时间：{{ header.startTime }} 至 {{ header.endTime }}</span>
              </div>
              <p></p>
              <p></p>
            </div>
          </div>
          <div class="division">1. 当前资源库总体情况</div>
          <h4>1.1 当前资源库用户情况</h4>
          <p>
            当前该资源库的用户总数{{ dataHandler(resourceLibrary.total) }}人，其中学生{{
              dataHandler(resourceLibrary.studentNum)
            }}人；教师{{ dataHandler(resourceLibrary.teacherNum) }}人；社会学习者{{
              dataHandler(resourceLibrary.socialNum)
            }}人；企业用户{{ dataHandler(resourceLibrary.enterpriseNum) }}人。具体如图1所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="resourceLibrary.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :legendListFontSize="30"
            ></circularChart>
          </div>
          <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
        </div>
        <div>
          <h4>1.2 当前资源库建设单位注册用户情况</h4>
          <p>
            当前该资源库建设单位教师用户{{
              dataHandler(userCountUnit.teacherNum)
            }}人，其中主持单位的教师用户{{
              dataHandler(userCountUnit.zcteacherNum)
            }}人，参建单位的教师用户{{
              dataHandler(userCountUnit.cjteacherNum)
            }}人；建设单位学生用户{{
              dataHandler(userCountUnit.studentNum)
            }}人，其中主持单位的学生用户{{
              dataHandler(userCountUnit.zcstudentNum)
            }}人，参建单位的学生用户{{ dataHandler(userCountUnit.cjstudentNum) }}人。具体如图2所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="userCountUnit.teacherList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
              :legendListFontSize="30"
            ></circularChart>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'resourceLibraryChart'"
              :isShowTextColor="true"
              :datas="userCountUnit.studentList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'55%'"
              :circleSize="80"
              :legendListFontSize="30"
            ></circularChart>
          </div>
          <div class="chart_name">图2 当前资源库建设单位注册用户情况</div>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>1.3 当前资源库资源建设情况</h4>
        <p>
          当前该资源库的素材资源总数{{ dataHandler(typeDistribution.total) }}条，其中文本类{{
            dataHandler(typeDistribution.wbNumber)
          }}条；图形图像类{{ dataHandler(typeDistribution.txtxNumber) }}条；视频类{{
            dataHandler(typeDistribution.spNumber)
          }}条；动画类{{ dataHandler(typeDistribution.dhNumber) }}条；虚拟仿真类{{
            dataHandler(typeDistribution.xnfzNumber)
          }}条；微课类{{ dataHandler(typeDistribution.wkNumber) }}条；音频类{{
            dataHandler(typeDistribution.ypNumber)
          }}条；ppt和富媒体等{{
            dataHandler(
              typeDistribution.pptNumber + typeDistribution.kjNumber + typeDistribution.fmtNumber
            )
          }}条；其他{{ dataHandler(typeDistribution.qtNumber) }}条。具体如图3所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="typeDistribution.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="chart_name">图3 资源库素材资源类型分布</div>
        <h4 class="m-top150">1.4 当前资源库标准化课程建设及应用情况</h4>
        <p>
          当前该资源库建有标准化课程{{
            dataHandler(standardization.courseBzNum)
          }}门，按访问量排名前10名如图4所示。
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :refId="'standardizationChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="standardization.dataList"
            :transverseData="standardization.transverseData"
            :colorList="standardization.colorList"
            :seriesColor="true"
          >
          </tcolumnarChart>
        </div>
        <div class="chart_name">图4 该资源库标准化课程访问量排名（前10名）</div>
        <div class="notes">
          （
          注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>1.5 当前资源库用户行为类型分布</h4>
        <p>
          该资源库用户行为活动总量为{{ dataHandler(behaviorTypes.total) }}次，其中课程模块{{
            dataHandler(behaviorTypes.courseModule)
          }}次，资源素材模块{{ dataHandler(behaviorTypes.resourceModule) }}次，论坛模块{{
            dataHandler(behaviorTypes.forumModule)
          }}次，作业模块{{ dataHandler(behaviorTypes.taskModule) }}次，考试模块{{
            dataHandler(behaviorTypes.examinationModule)
          }}次，其他模块{{ dataHandler(behaviorTypes.otherModule) }}次。具体如图5所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'behaviorTypesChart'"
            :datas="behaviorTypes.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="chart_name">图5 资源库用户行为类型分布</div>
        <h4 class="m-top150">1.6 资源库无活动数据情况</h4>
        <p>
          该资源库建设单位已实名教师总数{{
            dataHandler(resourcePool.realTeacher)
          }}人，其中无活动教师
          {{ dataHandler(resourcePool.countTeacher) }}人；建设单位近三年已实名学生总数{{
            dataHandler(resourcePool.realStudent)
          }}人，其中近三年无活动学生{{ dataHandler(resourcePool.countStudent) }}人；资源总数{{
            dataHandler(typeDistribution.total)
          }}条，其中无访问资源{{
            dataHandler(resourcePool.countResource)
          }}条；请继续关注应用情况，监督其深入应用。具体如图6所示。
        </p>
        <div class="speed">
          <el-row>
            <el-col :span="10">
              <div class="right">实名教师中无活动教师占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="teacherFormat"
                :percentage="waterDrop.teacher"
                color="#3B86FF"
              ></el-progress>
            </el-col>

            <el-col :span="10">
              <div class="right">实名学生中无活动学生占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="studentFormat"
                :percentage="waterDrop.student"
                color="#63D0FF"
              ></el-progress>
            </el-col>

            <el-col :span="10">
              <div class="right">无访问资源占比:</div>
            </el-col>
            <el-col :span="14">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :format="resourceFormat"
                :percentage="waterDrop.resource"
                color="#BBA8FF"
              ></el-progress>
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图6 资源库无活动数据情况</div>
        <div>
          <h4 class="m-top150">1.7 资源库综合排名情况</h4>
          <p v-if="top.zykRank <= 188">
            当前，该资源库建设单位已实名但无活动用户数（教师和学生）{{
            top.noStudentAndTearch
            }}人；该资源库无活动资源{{ top.noActiveResource }}条。
            根据资源库开展应用情况，取半年度访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名第{{
            top.zykRank
            }}名，请继续深入推广应用。
          </p>
          <p v-if="top.zykRank > 188">
            当前，该资源库建设单位已实名但无活动用户数（教师和学生总数）{{
            top.noStudentAndTearch
            }}人；该资源库无活动资源{{ top.noActiveResource }}条。
            根据资源库开展应用情况，取半年度访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名属于后15名，请加大资源库的推广应用力度。
          </p>
        </div>
      </div>
      <div class="chart_box page-box">
        <div class="division">2. {{ yearText }}年上半年资源库新增情况</div>
        <h4>2.1 用户新增情况</h4>
        <p>
          {{ yearText }}年上半年，该资源库新增教师用户数{{
            usersMonth.teacherNum
          }}人，新增学生用户数{{ usersMonth.studentNum }}人，新增企业用户数{{
            usersMonth.enterpriseNum
          }}人，新增社会学习者用户数{{ usersMonth.socialNum }}人。具体新增情况如图7所示。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :datas="usersMonth.dataList"
            :transverseData="usersMonth.transverseData"
            :colorList="usersMonth.colorList"
            :legendList="usersMonth.legendList"
            :innerText="'单位：人'"
            :isShowTextColor="true"
            :isExportTextColor="true"
          >
          </discountChart>
        </div>
        <div class="chart_name">图7 {{ yearText }}年上半年用户新增情况</div>
        <p class="m-top150">
          {{ yearText }}年上半年，该资源库新增用户中，主持单位新增教师数{{
            dataHandler(majorUser.teacher)
          }}人，参建单位新增教师数{{ dataHandler(majorUser.cjteacher) }}人，主持单位新增学生数{{
            dataHandler(majorUser.student)
          }}人，参建单位新增学生数{{
            dataHandler(majorUser.cjstudent)
          }}人，主持单位与参建单位新增占比情况具体如图8所示。
        </p>
        <div class="speed">
          <el-row>
            <el-col :span="6">
              <div style="font-size: 29px">主持单位新增教师占比:</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.majorteacherNum"
                color="#3B86FF"
              ></el-progress>
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">参建单位新增教师占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.unitteacherNum"
                color="#63D0FF"
              ></el-progress>
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">主持单位新增学生占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.majorstudentNum"
                color="#BBA8FF"
              ></el-progress>
            </el-col>
            <el-col :span="6">
              <div style="font-size: 29px">参建单位学生新增占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress
                :text-inside="true"
                :stroke-width="40"
                :percentage="waterDrop.unitstudentNum"
                color="#7F88FE"
              ></el-progress>
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图8 {{ yearText }}年上半年主持单位与参建单位新增用户占比情况</div>
      </div>
      <div class="chart_box page-box">
        <h4>2.2 素材资源新增情况</h4>
        <p>
          {{ yearText }}年上半年，该资源库新增素材资源{{
            dataHandler(resourcesMonth.total)
          }}条，具体新增情况如图9所示。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'resourcesInsertChart'"
            :datas="resourcesInsert.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'55%'"
            :showValue="true"
            :unit="'个'"
            :circleSize="80"
            :legendListFontSize="30"
          ></circularChart>
        </div>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'resourcesMonthChart'"
            :legendList="resourcesMonth.legendList"
            :datas="resourcesMonth.dataList"
            :transverseData="resourcesMonth.transverseData"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          ></vcolumnarChart>
        </div>
        <div class="chart_name">图9 {{ yearText }}年上半年资源新增情况</div>
        <h4 class="m-top150">2.3 课程新增情况</h4>
        <p>
          {{ yearText }}年上半年，该资源库新增课程总数{{ coursesMonth.total }}门，其中标准化课程{{
            coursesMonth.standard
          }}门，个性化课程{{ coursesMonth.personal }}门。具体新增情况如图10所示。
        </p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :refId="'lastcoursesMonthChart'"
            :legendList="coursesMonth.legendList"
            :datas="coursesMonth.dataList"
            :transverseData="coursesMonth.transverseData"
            :colorList="barColorList"
            :colorName="1"
            :innerText="'单位：门'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isShowTextColor="true"
            :isExportTextColor="true"
          ></vcolumnarChart>
        </div>
        <div class="chart_name divorced">图10 {{ yearText }}年上半年课程新增情况</div>
      </div>
      <div class="chart_box page-box">
        <div class="division">3. {{ yearText }}年上半年资源库应用情况</div>
        <div class="flex-box">
          <div>
            <h4>3.1 资源访问情况</h4>
            <p>
              {{ yearText }}年上半年，该资源库资源访问量为{{
                dataHandler(accessMonth.total)
              }}次，具体访问情况如图11所示。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'accessMonthChart'"
                :datas="accessMonth.dataList"
                :transverseData="accessMonth.transverseData"
                :colorList="accessMonth.colorList"
                :legendList="accessMonth.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              ></discountChart>
            </div>
            <div class="chart_name">图11 {{ yearText }}年上半年资源访问情况</div>
          </div>
          <div>
            <h4>3.2 课程访问情况</h4>
            <p>
              {{ yearText }}年上半年，该资源库课程访问量为{{
                dataHandler(visitsMonth.total)
              }}次，具体访问情况如图12所示。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'visitsMonthChart'"
                :datas="visitsMonth.dataList"
                :transverseData="visitsMonth.transverseData"
                :colorList="visitsMonth.colorList"
                :legendList="visitsMonth.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              ></discountChart>
            </div>
            <div class="chart_name">图12 {{ yearText }}年上半年课程访问情况</div>
          </div>
          <div>
            <h4>3.3 用户访问情况</h4>
            <p>
              {{ yearText }}年上半年，该资源库用户访问量为{{
                dataHandler(userAccessMonth.total)
              }}次，具体访问情况如图13所示。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userAccessMonthChart'"
                :datas="userAccessMonth.dataList"
                :transverseData="userAccessMonth.transverseData"
                :colorList="userAccessMonth.colorList"
                :legendList="userAccessMonth.legendList"
                :innerText="'单位：次'"
                :isShowTextColor="true"
                :isExportTextColor="true"
              ></discountChart>
            </div>
            <div class="chart_name">图13 {{ yearText }}年上半年用户访问情况</div>
          </div>
        </div>
      </div>
      <div class="chart_box page-box">
        <p>用户访问时间段分布具体如图14所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'userAccessMonthChart'"
            :datas="behaviorUser.dataList"
            :transverseData="behaviorUser.transverseData"
            :colorList="colorList"
            :legendList="behaviorUser.legendList"
            :innerText="'单位：次'"
            :isShowTextColor="true"
            :isExportTextColor="true"
          ></discountChart>
        </div>
        <div class="chart_name">图14 {{ yearText }}年上半年用户访问时间段分布</div>
        <h4 class="m-top150">3.4 {{ yearText }}年上半年访问量较多的教师</h4>
        <div class="chart_name" v-if="tearcherList.dataList.length === 10">
          表1 {{ yearText }}年上半年访问量较多的教师（前10名）
        </div>
        <div class="chart_name" v-else>表1 {{ yearText }}年上半年访问量较多的教师</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in tearcherList.dataList"
              :key="index"
              v-show="tearcherList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.author }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="tearcherList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.5 {{ yearText }}年上半年访问量较多的学生</h4>
        <div class="chart_name" v-if="studentList.dataList.length === 10">
          表2 {{ yearText }}年上半年访问量较多的学生（前10名）
        </div>
        <div class="chart_name" v-else>表2 {{ yearText }}年上半年访问量较多的学生</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in studentList.dataList"
              :key="index"
              v-show="studentList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.author }}</td>
              <td>{{ item.school }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="studentList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>3.6 {{ yearText }}年上半年访问量较多的资源</h4>
        <div class="chart_name" v-if="resourcesList.dataList.length === 10">
          表3 {{ yearText }}年上半年访问量较多的资源（前10名）
        </div>
        <div class="chart_name" v-else>表3 {{ yearText }}年上半年访问量较多的资源</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源名</th>
              <th>资源类型</th>
              <th>创建者姓名</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in resourcesList.dataList"
              :key="index"
              v-show="resourcesList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.mediaType }}</td>
              <td>{{ item.author }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="resourcesList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.7 {{ yearText }}年上半年活跃人数较多的课程</h4>
        <div class="chart_name" v-if="courseList.dataList.length === 10">
          表4 {{ yearText }}年上半年活跃人数较多的课程（前10名）
        </div>
        <div class="chart_name" v-else>表4 {{ yearText }}年上半年活跃人数较多的课程</div>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名</th>
              <th>类型</th>
              <th>创建者姓名</th>
              <th>活跃人数</th>
            </tr>

            <tr
              v-for="(item, index) in courseList.dataList"
              :key="index"
              v-show="courseList.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.author }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
            <tr v-show="courseList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表

import pageToPDF from "@/utils/htmlToPdf.js";

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
  },
  data() {
    return {
      completeNum: 0, //统计接口数量
      year: "",
      yearAndMonthly: "",
      yearText: "",
      zykStatus: "已立项",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      barColorList: ["#3B85FB", "#BBA8FF"],
      header: {
        allHostUnit: "",
        coHostUnit: [],
        endTime: "",
        hostUnit: "",
        startTime: "",
        status: "",
        zykName: "",
        zykNum: "",
      },

      resourceLibrary: {
        // 图1 资源库注册用户类型分布总体情况
        dataList: [],
        total: 0,
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
      },
      userCountUnit: {
        //图2 当前资源库参建单位注册用户情况（主持单位学生 + 老师，参建单位用户人数）
        teacherList: [],
        studentList: [],
        teacherNum: 0,
        studentNum: 0,
        zcteacherNum: 0,
        zcstudentNum: 0,
      },
      standardization: {
        //图4 该资源库标准化课程活跃用户排名
        dataList: [],
        transverseData: [],
        colorList: [],
        courseBzNum: 0,
      },
      behaviorTypes: {
        //图5 资源库用户行为类型分布
        dataList: [],
        total: 0,
        loginModule: 0,
        courseModule: 0,
        resourceModule: 0,
        forumModule: 0,
        taskModule: 0,
        examinationModule: 0,
        otherModule: 0,
      },
      //图14 上半年用户访问时间段分布
      behaviorUser: {
        dataList: [],
        transverseData: [],
        legendList: [],
      },
      resourcePool: {
        //图6 资源库无活动数据情况,图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况
        countTeacher: 0,
        countStudent: 0,
        realTeacher: 0,
        realStudent: 0,
        countResource: 0,
      },
      typeDistribution: {
        // 图2  当前资源库资源、课程情况
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },

      usersMonth: {
        // 图3 用户新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,
      },
      resourcesMonth: {
        // 图4 资源库各类型素材资源新增情况
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: [],
        total: 0,
      },
      resourcesInsert: {
        //图5 资源库用户行为类型分布
        dataList: [],
      },
      coursesMonth: {
        // 图5 课程新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
        standard: 0,
        personal: 0,
      },
      accessMonth: {
        // 图6 资源访问情况
        dataList: [],
        transverse: [],
        colorList: [],
        legendList: [],
      },
      visitsMonth: {
        // 图7 课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      userAccessMonth: {
        // 图8 用户访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },
      waterDrop: {
        teacher: 0, //图6 资源库无活动数据情况
        student: 0, //图6 资源库无活动数据情况
        resource: 0, //图6 资源库无活动数据情况
        // lastresource: 0,    //图11 资源库无访问资源较上月变化情况
        majorteacher: 0, //图8 主持院校与参建院校新增占比情况
        majorstudent: 0, //图8 主持院校与参建院校新增占比情况
        unitteacher: 0, //图8 主持院校与参建院校新增占比情况
        unitstudent: 0, //图8 主持院校与参建院校新增占比情况
        teacherNum: 0,
        studentNum: 0,
        resourceNum: 0,
        lastresourceNum: 0,
        majorteacherNum: 0,
        majorstudentNum: 0,
        unitteacherNum: 0,
        unitstudentNum: 0,
      },
      majorUser: {
        //图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0,
      },
      tearcherList: {
        // 图9  总访问量最多的教师
        dataList: [],
      },

      studentList: {
        // 图10 总访问量最多的学生
        dataList: [],
      },
      resourcesList: {
        // 图10 总访问量最多的资源
        dataList: [],
      },
      courseList: {
        // 图10 总访问量最多的课程
        dataList: [],
      },
      top: {
        realTeacher: 0,
        realStudent: 0,
        noActiveRealTeacher: 0,
        noActiveRealStudent: 0,
        noActiveResource: 0,
        logCount: 0,
        zykRank: 0,
        noStudentAndTearch: 0,
      },
      totalNum: 0,
      loading: "", // 是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      console.log(this.$route.query);
      this.header = this.$route.query;
      let token = this.$route.query.token;
      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid);
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      //const year = this.$route.query.yearOrMonth
      //const monthly = this.$route.query.yearOrMonth
      // const year = this.$route.query.yearOrMonth.substring(0, 4);
      // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
      //this.$route.query.startTime = `${year}-${monthly}-${1}`;
      //this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header.zykNum = this.$route.query.zykNum;
      //this.year = `${year}-${monthly}`;
      //this.yearAndMonthly = this.$route.query.yearOrMonth;
    }
    setTimeout(() => {
      this.getZykStatus(); //   获取资源库状态
      this.fenxi(); //   年度基本信息
      this.resourceLibraryDom(); //  图1  资源库注册用户类型分布总体情况
      this.typeDistributionDom(); //  图2  当前资源库资源、课程情况
      this.getUserCountUnitDom(); // 当前资源库建设单位注册用户情况
      this.standardizationDom();
      this.behaviorTypesDom();
      this.resourcePoolDom();
      this.getLrmv2YearBehaviorUserCourseLog(); //图14 上半年用户访问时间段分布
      // this.usersMonthDom(); //  图3  用户新增情况(教师,学生)
      this.resourcesMonthDom(); //   图4  素材资源新增情况、
      this.tops()                 //        排名
      // this.coursesMonthDom(); //   图5  课程新增
      this.getStudyList(); //   标准化课程数
      this.accessMonthDom(); //   图6  资源访问情况
      this.visitsMonthDom(); //   图7  课程访问情况
      this.userAccessMonthDom(); //   图8  用户访问情况
      this.tearcherTop(); //   图9  教师访问量前十排名
      this.studentTop(); //    图10 学生访问量前十排名
      this.resourcesTop(); //   表3  资源访问量前十排名
      this.courseTop(); //    表4 课程访问量前十排名
    }, 2000);
  },
  methods: {
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let name = this.header.zykName.split("(");
      let newName = "";
      let oldName = "";
      let zykName = "";
      if (name.length > 1) {
        newName = name[0];
        oldName = name[1].replace(")", "");
        zykName = `${newName}（原专业名称：${oldName}）`;
      } else zykName = this.header.zykName;
      pageToPDF(`${this.header.zykNum}_${zykName}_半年报`, this.$refs.pdfContent, lableList);
    },
    // 切换专业
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            this.completeNum = this.completeNum + 1;
            sessionStorage.setItem("zykId", e);
            this.reload();
          }
        });
    },
    reload() {
      //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 获取资源库状态
    getZykStatus() {
      this.$axios
        .post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem("zykId"), {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            this.zykStatus = res.data;
          }
        });
    },

    // 年度基本信息
    fenxi() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.header = res.data;
          this.yearText = parseInt(res.data.startTime.slice(0, 4));
          this.usersMonthDomAndMajorUser(); // 图7、图8 本月用户新增情况、主持院校与参建院校新增占比情况 同步请求
          this.resourcesInsertDom();
          this.coursesMonthDom();
          this.header.allHostUnit = this.header.allHostUnit.replaceAll(",", "，");
        });
    },
    // 图1 资源库注册用户类型分布总体情况
    resourceLibraryDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourceLibrary, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            const arrList = [];
            arrList.push(
              {
                name: "教师",
                value: res.data.teacherNum,
              },
              {
                name: "学生",
                value: res.data.studentNum,
              },
              {
                name: "社会学习者",
                value: res.data.socialNum,
              },
              {
                name: "企业用户",
                value: res.data.enterpriseNum,
              }
            );
            this.resourceLibrary.total = res.data.totalNum;
            this.resourceLibrary.teacherNum = res.data.teacherNum;
            this.resourceLibrary.studentNum = res.data.studentNum;
            this.resourceLibrary.socialNum = res.data.socialNum;
            this.resourceLibrary.enterpriseNum = res.data.enterpriseNum;
            this.resourceLibrary.dataList = arrList;
          }
        });
    },
    //图2 当前资源库参建单位注册用户情况
    getUserCountUnitDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_getUserCountUnit, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            var studentList = [];
            var teacherList = [];
            this.userCountUnit.cjteacherNum = res.data.teacherNum;
            this.userCountUnit.cjstudentNum = res.data.studentNum;
            this.userCountUnit.zcteacherNum = res.data.enterpriseNum;
            this.userCountUnit.zcstudentNum = res.data.socialNum;
            this.userCountUnit.teacherNum = res.data.teacherNum + res.data.enterpriseNum;
            this.userCountUnit.studentNum = res.data.studentNum + res.data.socialNum;

            teacherList.push(
              {
                name: "主持单位教师",
                value: res.data.enterpriseNum,
              },
              {
                name: "参建单位教师",
                value: res.data.teacherNum,
              }
            );

            studentList.push(
              {
                name: "主持单位学生",
                value: res.data.socialNum,
              },
              {
                name: "参建单位学生",
                value: res.data.studentNum,
              }
            );
            this.userCountUnit.studentList = studentList;
            this.userCountUnit.teacherList = teacherList;
          }
        });
    },
    // 图4 该资源库标准化课程访问量排名
    standardizationDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_standardization, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            var name = [];
            var value = [];
            for (let i = 0; i < res.data.lrmv2UserResourceCourseRankingLogEntities.length; i++) {
              name.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].name);
              value.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].num);
            }
            this.standardization.dataList = value;
            this.standardization.transverseData = name;
            this.standardization.colorList = this.colorList;
            this.standardization.courseBzNum = res.data.courseBzNum;
          }
        });
    },
    // 图5 资源库用户行为类型分布
    behaviorTypesDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_behaviorTypes, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            var arrList = [];
            arrList.push(
              {
                name: "课程模块",
                value: res.data.courseModule,
              },
              {
                name: "资源素材模块",
                value: res.data.resourceModule,
              },
              {
                name: "论坛模块",
                value: res.data.forumModule,
              },
              {
                name: "作业模块",
                value: res.data.taskModule,
              },
              {
                name: "考试模块",
                value: res.data.examinationModule,
              },
              {
                name: "其他模块",
                value: res.data.otherModule,
              }
            );
            this.behaviorTypes.loginModule = res.data.loginModule;
            this.behaviorTypes.courseModule = res.data.courseModule;
            this.behaviorTypes.resourceModule = res.data.resourceModule;
            this.behaviorTypes.forumModule = res.data.forumModule;
            this.behaviorTypes.taskModule = res.data.taskModule;
            this.behaviorTypes.examinationModule = res.data.examinationModule;
            this.behaviorTypes.otherModule = res.data.otherModule;
            this.behaviorTypes.total = res.data.total;
            this.behaviorTypes.dataList = arrList;
          }
        });
    },
    // 图6 资源库无活动数据情况
    resourcePoolDom() {
      this.$axios
        .post(this.$apiurls.report_monthly_resourcePool, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            this.resourcePool = res.data;
            this.waterDrop.teacher =
              (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                ? Math.round((this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100)
                : 0;
            this.waterDrop.student =
              (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                ? Math.round((this.resourcePool.countStudent / this.resourcePool.realStudent) * 100)
                : 0;
            this.waterDrop.resource =
              (this.resourcePool.countResource / this.typeDistribution.total) * 100
                ? Math.round((this.resourcePool.countResource / this.typeDistribution.total) * 100)
                : 0;
            this.waterDrop.teacherNum =
              (this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100
                ? ((this.resourcePool.countTeacher / this.resourcePool.realTeacher) * 100).toFixed(
                    2
                  )
                : 0;
            this.waterDrop.studentNum =
              (this.resourcePool.countStudent / this.resourcePool.realStudent) * 100
                ? ((this.resourcePool.countStudent / this.resourcePool.realStudent) * 100).toFixed(
                    2
                  )
                : 0;
            this.waterDrop.resourceNum =
              (this.resourcePool.countResource / this.typeDistribution.total) * 100
                ? ((this.resourcePool.countResource / this.typeDistribution.total) * 100).toFixed(2)
                : 0;
            // this.getLrmv2MonthUserCourseResource();
            1;
          }
        });
    },
    //图14 上半年用户访问时间段分布
    getLrmv2YearBehaviorUserCourseLog() {
      this.$axios
        .post(this.$apiurls.getLrmv2YearBehaviorUserCourseLog, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            let arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              arrList.push([
                res.data[i].behaviorOne,
                res.data[i].behaviorTwo,
                res.data[i].behaviorThree,
                res.data[i].behaviorFour,
                res.data[i].behaviorFive,
                res.data[i].behaviorSix,
                res.data[i].behaviorSeven,
                res.data[i].behaviorEight,
              ]);
            }
            this.behaviorUser.dataList = arrList;
            this.behaviorUser.transverseData = [
              "00：00—03：00",
              "03：00—06：00",
              "06：00—09：00",
              "09：00—12：00",
              "12：00—15：00",
              "15：00—18：00",
              "18：00—21：00",
              "21：00—00：00",
            ];
            this.behaviorUser.legendList = [
              "教师行为",
              "学生行为",
              "企业用户行为",
              "社会学习者行为",
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 图2 当前资源库资源、课程情况
    typeDistributionDom() {
      this.$axios
        .post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            const arrList = [];
            arrList.push(
              {
                name: "视频类",
                value: res.data.videoNum,
              },
              {
                name: "动画类",
                value: res.data.animationNum,
              },
              {
                name: "图形图像类",
                value: res.data.graphicImageNum,
              },
              {
                name: "虚拟仿真类",
                value: res.data.virtualSimulationNum,
              },
              {
                name: "文本类",
                value: res.data.textNum,
              },
              {
                name: "微课类",
                value: res.data.smallCourseNum,
              },
              {
                name: "音频类",
                value: res.data.shenyangNum,
              },
              {
                name: "ppt和富媒体等",
                value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum,
              },
              {
                name: "其他",
                value: res.data.otherNum,
              }
            );
            this.typeDistribution.spNumber = res.data.videoNum;
            this.typeDistribution.dhNumber = res.data.animationNum;
            this.typeDistribution.txtxNumber = res.data.graphicImageNum;
            this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum;
            this.typeDistribution.wbNumber = res.data.textNum;
            this.typeDistribution.wkNumber = res.data.smallCourseNum;
            this.typeDistribution.ypNumber = res.data.shenyangNum;
            this.typeDistribution.kjNumber = res.data.coursewareNum;
            this.typeDistribution.pptNumber = res.data.pptNum;
            this.typeDistribution.fmtNumber = res.data.mediaNum;
            this.typeDistribution.qtNumber = res.data.otherNum;
            this.typeDistribution.total = res.data.total;
            this.typeDistribution.dataList = arrList;
          }
        });
    },

    // 图3 用户新增情况
    usersMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 1, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            const arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              arrList.push(res.data[i].value);
            }

            let teacherNum = 0;
            let studentNum = 0;
            // 新增教师的数量
            let teacherArray = res.data[0].value;
            for (let i = 0; i <= teacherArray.length - 1; i++) {
              teacherNum += parseFloat(teacherArray[i]);
            }

            // 新增学生的数量
            let studentArray = res.data[1].value;
            for (let i = 0; i <= studentArray.length - 1; i++) {
              studentNum += parseFloat(studentArray[i]);
            }

            this.usersMonth.dataList = arrList;
            this.usersMonth.transverseData = res.data[0].name;
            this.usersMonth.legendList = ["教师", "学生"];
            this.usersMonth.colorList = this.colorList;
            this.usersMonth.teacherNum = teacherNum;
            this.usersMonth.studentNum = studentNum;
            this.usersMonth.total = teacherNum + studentNum;
          }
        });
    },
    usersMonthDomAndMajorUser() {
      //同步发送请求
      //图7 本月用户新增情况
      var p1 = new Promise((resolve, reject) => {
        this.$axios
          .post(this.$apiurls.report_year_getYearhZykAdd, 1, {
            loading: false,
          })
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
      //图8 主持院校与参建院校新增占比情况
      var p2 = new Promise((resolve, reject) => {
        this.$axios
          .post(this.$apiurls.getZykUnitUserYearAdd, this.yearText, {
            loading: false,
          })
          .then((res) => {
            this.completeNum = this.completeNum + 1;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([p1, p2]).then((res) => {
        //图7 本月用户新增情况
        var teacherNum = 0;
        var studentNum = 0;
        var enterpriseNum = 0;
        var socialNum = 0;
        const arrList = [];
        let res1 = res[0];
        for (let i = 0; i < res1.length; i++) {
          arrList.push(res1[i].value);
        }
        for (let i = 0; i < res1[0].value.length; i++) {
          teacherNum += parseFloat(res1[0].value[i]);
        }
        for (let i = 0; i < res1[1].value.length; i++) {
          studentNum += parseFloat(res1[1].value[i]);
        }
        for (let i = 0; i < res1[1].value.length; i++) {
          enterpriseNum += parseFloat(res1[2].value[i]);
        }
        for (let i = 0; i < res1[1].value.length; i++) {
          socialNum += parseFloat(res1[3].value[i]);
        }
        this.usersMonth.dataList = arrList;
        this.usersMonth.transverseData = res1[0].name;
        this.usersMonth.legendList = ["教师", "学生", "企业用户", "社会学习者"];
        this.usersMonth.colorList = this.colorList;
        this.usersMonth.teacherNum = teacherNum;
        this.usersMonth.studentNum = studentNum;
        this.usersMonth.enterpriseNum = enterpriseNum;
        this.usersMonth.socialNum = socialNum;
        this.usersMonth.total = teacherNum + studentNum + enterpriseNum + socialNum;

        //图8 主持院校与参建院校新增占比情况
        let res2 = res[1];
        this.majorUser.teacher = res2.teacher ? res2.teacher : 0;
        this.majorUser.student = res2.student ? res2.student : 0;
        this.majorUser.cjteacher = res2.cjteacher ? res2.cjteacher : 0;
        this.majorUser.cjstudent = res2.cjstudent ? res2.cjstudent : 0;

        this.waterDrop.majorteacherNum = parseFloat(
          this.usersMonth.teacherNum
            ? ((this.majorUser.teacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.majorstudentNum = parseFloat(
          this.usersMonth.studentNum
            ? ((this.majorUser.student / this.usersMonth.studentNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitteacherNum = parseFloat(
          this.usersMonth.teacherNum
            ? ((this.majorUser.cjteacher / this.usersMonth.teacherNum) * 100).toFixed(2)
            : 0
        );
        this.waterDrop.unitstudentNum = parseFloat(
          this.usersMonth.studentNum
            ? ((this.majorUser.cjstudent / this.usersMonth.studentNum) * 100 < 1
                ? (this.majorUser.cjstudent / this.usersMonth.studentNum) * 100
                : (this.majorUser.cjstudent / this.usersMonth.studentNum) * 100
              ).toFixed(2)
            : 0
        );
      });
    },
    // 图4 素材资源新增情况
    resourcesMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 9, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          let newArray = res.data[0].value;
          this.resourcesMonth.dataList = newArray;
          this.resourcesMonth.legendList = ["新增资源"];
          this.resourcesMonth.transverseData = res.data[0].name;
        });
    },
    resourcesInsertDom() {
      this.$axios
        .post(this.$apiurls.getResourceAddType, this.yearText, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.completeNum = this.completeNum + 1;
            var arrList = [];
            var number = 0;
            let total = 0;
            let newArray = res.data;
            for (const item of newArray) {
              switch (item.name) {
                case "视频":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "动画":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "图形图像":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "虚拟仿真":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "文本":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "微课":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "音频":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
                case "课件":
                  number += item.value;
                  break;
                case "ppt":
                  number += item.value;
                  break;
                case "富媒体":
                  number += item.value;
                  break;
                case "其他":
                  arrList.push({
                    name: item.name,
                    value: item.value,
                  });
                  break;
              }
              total += parseFloat(item.value);
            }
            if (number > 0) {
              arrList.push({
                name: "ppt和富媒体等",
                value: number,
              });
            }
            this.resourcesMonth.total = total;
            this.resourcesInsert.dataList = arrList;
          }
        });
    },
    // 排名
    tops() {
      this.$axios.post(this.$apiurls.report_yaer_getZykRankYear, {
        loading: false
      }).then((res) => {
          this.top.realStudent = res.data.realStudent;
          this.top.realTeacher = res.data.realTeacher;
          this.top.noActiveRealStudent = res.data.noActiveRealStudent;
          this.top.noActiveRealTeacher = res.data.noActiveRealTeacher;
          this.top.noStudentAndTearch = res.data.noActiveRealStudent + res.data.noActiveRealTeacher;
          this.top.noActiveResource = res.data.noActiveResource;
          this.top.logCount = res.data.logCount;
          this.top.zykRank = res.data.zykRank;
          this.completeNum = this.completeNum + 1;
      })
    },
    // 标注化课程数
    getStudyList() {
      this.$axios
        .post(this.$apiurls.report_year_getYearStatStandardcourseaccessList, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.totalNum = res.data;
        });
    },

    // 图5 课程新增情况
    coursesMonthDom() {
      this.$axios
        .post(
          this.$apiurls.getQuarterCourseAdd,
          { startDate: this.header.startTime, endDate: this.header.endTime },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.coursesMonth.dataList = [res.data.standardCourse, res.data.personalityCourse];
          this.coursesMonth.legendList = ["标准化课程", "个性化课程"];
          this.coursesMonth.transverseData = res.data.time;
          this.coursesMonth.standard = res.data.standardCourse.reduce((a, b) => a + b, 0);
          this.coursesMonth.personal = res.data.personalityCourse.reduce((a, b) => a + b, 0);
          this.coursesMonth.total = this.coursesMonth.standard + this.coursesMonth.personal;
        });
    },

    // 图6 资源访问情况
    accessMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 4, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          let totalArray = res.data[0].value;
          let transverse = [];
          let total = 0;
          let arrList = [];
          for (let i = 0; i <= totalArray.length - 1; i++) {
            total += parseFloat(totalArray[i]);
          }
          for (let i = 0; i <= res.data.length - 1; i++) {
            transverse.push(res.data[i].name);
            arrList.push(res.data[i].value);
          }
          this.accessMonth.dataList = arrList;
          this.accessMonth.transverseData = res.data[0].name;
          this.accessMonth.legendList = ["资源访问"];
          this.accessMonth.colorList = this.colorList;
          this.accessMonth.total = total;
        });
    },

    // 图7 课程访问情况
    visitsMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 5, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          let nameArray = res.data[0].name;
          let valueArray = res.data[0].value;
          let total = 0;
          for (let i = 0; i <= valueArray.length - 1; i++) {
            total += parseFloat(valueArray[i]);
          }
          this.visitsMonth.dataList = valueArray;
          this.visitsMonth.transverseData = nameArray;
          this.visitsMonth.legendList = ["课程访问"];
          this.visitsMonth.colorList = this.colorList;
          this.visitsMonth.total = total;
        });
    },

    //图8  用户访问情况
    userAccessMonthDom() {
      this.$axios
        .post(this.$apiurls.report_year_getYearhZykAdd, 7, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          console.log(res.data, "asasas");
          let total = 0;
          let arrList = [];
          for (let i = 0; i < res.data.length; i++) {
            arrList.push(res.data[i].value);
          }
          let valArray = res.data.map((item) => item.value);
          valArray[0]
            .concat(valArray[1], valArray[2], valArray[3])
            .forEach((item) => (total += parseFloat(item)));
          this.userAccessMonth.total = total;
          this.userAccessMonth.dataList = arrList;
          this.userAccessMonth.transverseData = res.data[0].name;
          this.userAccessMonth.colorList = this.colorList;
          this.userAccessMonth.legendList = [
            "教师行为",
            "学生行为",
            "社会学习者行为",
            "企业用户行为",
          ];
        });
    },

    // 图9 总访问量较多的教师（前十）
    tearcherTop() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityList,
          { statType: 33, limitNum: 10 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.tearcherList.dataList = res.data;
        });
    },

    studentTop() {
      this.$axios
        .post(
          this.$apiurls.report_year_getStatLittletenEntityList,
          { statType: 34, limitNum: 10 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.studentList.dataList = res.data;
        });
    },
    resourcesTop() {
      this.$axios
        .post(this.$apiurls.getLrmv2YearVisitCourseOrResourceRank, 35, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          this.resourcesList.dataList = res.data;
        });
    },
    courseTop() {
      this.$axios
        .post(this.$apiurls.getLrmv2YearVisitCourseOrResourceRank, 43, {
          loading: false,
        })
        .then((res) => {
          this.completeNum = this.completeNum + 1;
          let data = res.data;
          for (const item of data) {
            let arr = item.name.split("_");
            item.name = arr[0];
            item.type = arr[1];
          }
          this.courseList.dataList = data;
        });
    },
    // 数据改变
    dataHandler(data) {
      return data > 100000000
        ? (data / 100000000).toFixed(2) + "亿"
        : data > 10000
        ? (data / 10000).toFixed(2) + "万"
        : data;
    },
    // 进度条上的百分比值转化
    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.waterDrop.resourceNum}%`;
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /* width: 80%;
  margin: 0px auto;
  height: 10960px !important; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0 60px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 1.5625rem;
}

.number_time p {
  width: 100%;
  height: 0.0625rem;
  background: #707f9d;
  margin-top: 0.5rem;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 0.25rem;
}

.division {
  position: relative;
  clear: both;
  text-align: center;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 42px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 100px;
}

.chart_box p {
  font-size: 35px;
  text-indent: 2em;
  line-height: 60px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 100%;
  /* height: calc(100vw / 1080 * 300); */
  /* height: 400px; */
  height: 28rem;
  margin: 50px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.speed .el-col-6 {
  white-space: nowrap;
}

.chart_box .notes {
  margin: 35px;
  line-height: 50px;
  font-size: 30px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 0.625rem;
  top: 0.625rem;
  z-index: 1;
}

.center {
  text-align: center;
}

.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 1.5625rem;
}
</style>

<style>
::-webkit-scrollbar {
  width: 0px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}

.chart_box p {
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 380px;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 30px;
  color: #707f9d;
  clear: both;
  margin-top: 20px;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }

  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
